/**
 * Fetches and shows the result of the TasteProfileOnboarding questionnaire, initially showing a
 * loading screen
 */
/* global dataLayer */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import ResultDetail from '../ResultDetail'
import { selectResult } from './selectors'
import { TasteProfileIcon } from 'environments/TasteProfileOnboarding/components'
import { createTasteProfileEvent } from 'utils/tagManager'
import styles from './personalTasteProfile.css'

export class PersonalTasteProfile extends Component {
  constructor (props) {
    super(props)
    this.handleSelect = this.handleSelect.bind(this)
  }

  render () {
    const { result } = this.props
    const { red, white } = result

    return (
      <div className={styles.wrapper}>
        <Tabs onSelect={this.handleSelect}>
          <TabList className={classnames(styles.tabList, 'tasteprofile-tablist')}>
            <Tab className={classnames(styles.tab, 'tasteprofile-tab')} selectedClassName={styles.tabSelected}>
              <span className={styles.cornerLeft} />
              <span className={styles.cornerRight} />
              <span className={classnames(styles.label, 'tasteprofile-tab--label')}>Jouw rood</span>
              <div className={styles.iconWrapper}>
                <TasteProfileIcon profile={red.className} className={styles.tabIcon} width={0} />
              </div>
            </Tab>
            <Tab className={classnames(styles.tab, 'tasteprofile-tab')} selectedClassName={styles.tabSelected}>
              <span className={styles.cornerLeft} />
              <span className={styles.cornerRight} />
              <span className={classnames(styles.label, 'tasteprofile-tab--label')}>Jouw wit</span>
              <div className={styles.iconWrapper}>
                <TasteProfileIcon profile={white.className} className={styles.tabIcon} width={0} />
              </div>
            </Tab>
          </TabList>

          <div className={styles.tabContent}>
            <TabPanel className={styles.tabPanel}>
              <ResultDetail {...red} />
            </TabPanel>
            <TabPanel>
              <ResultDetail {...white} />
            </TabPanel>
          </div>
        </Tabs>
      </div>
    )
  }

  handleSelect (index) {
    dataLayer.push(
      createTasteProfileEvent(
        'switch kleur',
        index === 0 ? 'Rood' : 'Wit'
      )
    )
  }
}

PersonalTasteProfile.propTypes = {
  result: PropTypes.object.isRequired
}

const mapStateToProps = createStructuredSelector({
  result: selectResult
})

export default connect(mapStateToProps)(PersonalTasteProfile)
